// src/components/TenantGuard.jsx
import React from "react";
import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../contexts/AuthContext";
import { useTenantConfig } from "../contexts/TenantConfigContext";

export default function TenantGuard() {
  const { auth, keycloak, hasRole } = useAuth();
  const config = useTenantConfig();

  // Still loading auth state
  if (auth.loading) {
    return <div>Loading…</div>;
  }

  // Not logged in at all
  if (!auth.isAuthenticated) {
    return <Navigate to="/login" replace />;
  }

  if (hasRole("superadmin")) {
    return <Outlet />;
  }

  if (!config) {
    return (
      <div style={{ padding: "2rem", textAlign: "center", color: "red" }}>
        Tenant configuration missing.
      </div>
    );
  }

  const backendClientId = config.backendClientId; // e.g. "MyODS_JCM_BackEnd"
  const loginRole = config.loginRole; // e.g. "Login_JCM"

  const token = keycloak?.tokenParsed;
  const resourceAccess = token?.resource_access || {};
  const clientAccess = resourceAccess[backendClientId] || {};
  const roles = clientAccess.roles || [];

  const hasLoginRole = roles.includes(loginRole);

  if (!hasLoginRole) {
    // This is where ods1@encore.com on jcm.myods.club will land
    return (
      <div style={{ padding: "2rem", textAlign: "center" }}>
        <h2>Not authorized for this site</h2>
        <p>
          Your account does not have access to this club. Please make sure you
          are using the correct site URL or contact your administrator.
        </p>
      </div>
    );
  }

  // If we got here: user is logged in AND belongs to this tenant
  return <Outlet />;
}
